<template>
  <div>
    <div class="header-img">
      <div class="header-text">
        <h1>合作库共享平台</h1>
        <h2 class="characters">Cooperation</h2>
        <h2 class="characters">library</h2>
        <h2 class="characters">sharing</h2>
        <h2 class="characters">platform</h2>
      </div>
    </div>
    <div class="crumbs-contain">
      <div>
        您的位置：
        <router-link tag="a" to="Home" class="home-title">首页</router-link
        ><i class="fa fa-angle-right" aria-hidden="true"></i
        ><router-link tag="a" to="Cooperation" class="new-name"
          >合作库</router-link
        >
      </div>
    </div>
    <div class="innovative-service">
      <h1 class="server-text">合作库概述</h1>
      <h2 class="server-below">OVERVIEW OF COOPERATIVE LIBRARY</h2>
      <div class="introduction-contain">
        <div>
          <img src="../../../static/images/server18.png" alt="合作库概述" />
        </div>
        <div class="library-contain">
          <div class="library-text">
            合作库是设备配件资源共享平台。通过电子商务的模式整合客户库存资源和多方渠道资源，同时以供应链标准化管理体系为基础，对产品进行标准化管理，使其具备流通和交易的基础，平台为多方需求者提供统一标准化的优质产品，帮助用户把人员管理和配件管理进行分离，有效降低管理成本和备件支出成本。
          </div>
          <div class="library-text">
            平台为用户提供委托销售/租赁、委托代管、配件租赁、技术维修、物流配送、数据管理等一站式专业运营服务，为用户节省成本。
          </div>
          <div class="library-text">
            区域库管理可以帮助用户把人员管理和配件管理进行分离，有效降低管理成本。模块化的业务结构为客户提供多种选择。支持客户跨行业，多元化设备维护业务的拓展。
          </div>
        </div>
      </div>
      <div class="offer-serve">一、我们提供的服务</div>
      <div class="service-contain">
        <div class="service-img">
          <img src="../../../static/images/server16.png" alt="提供的服务" />
        </div>
      </div>
      <div class="offer-serve">二、合作业务范围</div>
      <div class="content-text">
        医疗行业，金融行业，IT行业。医疗自助设备，金融自助设备，IT设备，工业设备等
      </div>
    </div>
    <div class="overview-contain">
      <div class="libraries">
        <h1 class="libraries-title">合作库供应链</h1>
        <h2 class="libraries-name">COOPERATIVE WAREHOUSE SUPPLY CHAIN</h2>
        <div class="libraries-text">
          合作库供应链由自有库，VMI库、虚拟库、委托库（国内+香港）组成，合作库配件资源共享给合作库的用户（除用户的专属代管库外）。供应链服务体系由中心库统筹调拨运营、授权区域库运营管理，中心库优势是将信息与资源的快速集成、整合，统筹调拨给需求的用户。
        </div>
        <img src="../../../static/images/server17.png" alt="合作库供应链" />
      </div>
    </div>
    <div class="overview-contain1">
      <div class="libraries1">
        <h1 class="libraries-title1">区域合作库结构</h1>
        <h2 class="libraries-name1">
          STRUCTURE OF REGIONAL COOPERATION DATABASE
        </h2>
        <div class="libraries-text1">
          区域合作库是为就近满足区域用户的服务需求设立的，提供的业务：委托销售/租赁、委托代管+运营、技术维修与翻新、物流配送、数据管理等一站式的运营服务与解决方案，其中委托代管+运营服务，解决区域用户对运营管控不到位，库存数据信息反应慢等劣势，通过区域合作库专业的管理与安全保证，提升客户服务体验的同时降低用户的运营成本和风险。
        </div>
        <div class="area-contain">
          <div
            class="area-chunk"
            v-for="(item, index) in areaData"
            :key="index"
          >
            <img :src="item.img" :alt="item.title" />
            <div>{{ item.title }}</div>
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="overview-contain2">
      <div class="libraries2">
        <h1 class="libraries-title2">合作库运营支持</h1>
        <h2 class="libraries-name2">COOPERATION BASE OPERATION SUPPORT</h2>
        <div class="libraries-text2">
          合作库共享平台拥有专业运营团队，支持合作库的高效运营与服务用户，我们始终坚持以诚信·
          服务为用户创造价值。
        </div>
        <div class="support-contain">
          <div
            class="support-chunk"
            v-for="(item, index) in runData"
            :key="index"
          >
            <div class="support-left">
              <img :src="item.img" :alt="item.title" />
            </div>
            <div class="support-right">
              <div>{{ item.title }}</div>
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overview-contain3">
      <div class="libraries3">
        <h1 class="libraries-title3">质量管理体系</h1>
        <h2 class="libraries-name3">QUALITY MANAGEMENT SYSTEM</h2>
        <div class="libraries-text3">
          合作库共享平台制定并执行统一的质量管理标准与文件支持，通过统一配件的品项标准、条码识别管理，有效实现配件流通，数据的无缝连接，为用户提供售后服务保证。
        </div>
        <div class="quality-control">
          <div
            class="quality-chunk"
            v-for="(item, index) in qualityData"
            :key="index"
          >
            <div class="quality-header">
              <img :src="item.img" :alt="item.title" />
            </div>
            <div class="quality-title">{{ item.title }}</div>
            <div class="quality-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import bottom from "@/components/bottom";
export default {
  components: {
    bottom
  },
  data() {
    return {
      areaData: [
        {
          img: "../../../static/images/icon16.png",
          title: "委托库",
          name: "即共享库存，产品数据信息开放给平台的用户。"
        },
        {
          img: "../../../static/images/icon17.png",
          title: "代管库",
          name: "即委托代管用户的自有库，产品数据信息不开放给平台其它用户。"
        },
        {
          img: "../../../static/images/icon18.png",
          title: "维修中心",
          name: "提供正常售后保修和有偿保修支持。"
        },
        {
          img: "../../../static/images/icon19.png",
          title: "物流配送",
          name: "提供区域内时效必达的配送服务。"
        }
      ],
      runData: [
        {
          img: "../../../static/images/icon20.png",
          title: "仓储部",
          name:
            "负责产品的仓储管理，按仓储管理标准执行在日常管理、定期盘点、数据上传请具体事务上，出入库管理严格按先进先出、保质期到期再检原则保障质量安全。"
        },
        {
          img: "../../../static/images/icon21.png",
          title: "技术维修中心",
          name:
            "负责产品售后维修、委托维修、技术翻新、技术支持等具体事务，按相应标准执行作业管理。"
        },
        {
          img: "../../../static/images/icon22.png",
          title: "物流配送中心",
          name:
            "负责用户订单配送需求，保障配送安全、时效必达的基本要求，数据信息的即时上传等工作。"
        },
        {
          img: "../../../static/images/icon23.png",
          title: "系统维护中心",
          name:
            "负责整个供应链运营系统的维护、检查、数据备份……,保障服务平台的安全正常运营。"
        },
        {
          img: "../../../static/images/icon24.png",
          title: "数据中心",
          name:
            "负责运营过程中每个环节的数据检查，校对，汇总分析、资料存档、信息反馈等工作。"
        },
        {
          img: "../../../static/images/icon25.png",
          title: "客服中心",
          name:
            "负责解答线上、线下用户的业务咨询、客诉、售后服务、问题解答……等,记录信息并及时反馈回复等工作。"
        }
      ],
      qualityData: [
        {
          img: "../../../static/images/icon26.png",
          title: "品项标准",
          name:
            "执行统一的品质标准，每个产品从来料验收到出库，均按品质标准管理，便于分类仓传、流通、识别等环节的质量管控与追溯。"
        },
        {
          img: "../../../static/images/icon27.png",
          title: "质保标准",
          name:
            "依产品的类别不同，制定符合产品本身的仓储保质期管理，按期复检抽查，保障产品仓储质量安全。"
        },
        {
          img: "../../../static/images/icon28.png",
          title: "条码标准",
          name:
            "每个产品从来料检验是即生成唯一身份（条码），实现后期仓储、出库、售后……等流通环节的品质追溯、识别管理。"
        },
        {
          img: "../../../static/images/icon29.png",
          title: "翻新标准",
          name:
            "通过技术翻新处理，使二手件达到八成新或以上，保证翻新件使用寿命，实现资源价值转化最大化。"
        },
        {
          img: "../../../static/images/icon30.png",
          title: "验收标准",
          name:
            "严格执行的验收标准、管理流程，把控产品出、入库检验环节的质量关，把质量控制在源头，以保障客户利益。"
        },
        {
          img: "../../../static/images/icon31.png",
          title: "包装标准",
          name:
            "我们根据每种产品的特性制定符合产品储存、识别与运输的包装标准，以保障产品储存和运输安全。"
        }
      ]
    };
  },
  methods: {}
};
</script>

<style scoped lang="less">
.header-img {
  width: 100%;
  height: 550px;
  background: url(../../../static/images/server13.jpg) no-repeat center center;
  .header-text {
    width: 1170px;
    padding-top: 100px;
    margin: 0 auto;
    h1 {
      font-size: 40px;
      font-weight: 300;
      line-height: 5px;
      color: #3488ea;
      margin-bottom: 45px;
    }
    .characters {
      font-size: 40px;
      color: #464646;
      opacity: 0.8;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
      line-height: 15px;
    }
  }
}
.crumbs-contain {
  width: 1170px;
  margin: 0 auto;
  padding: 30px 0;
  color: #666666;
  font-size: 12px;
  .home-title {
    cursor: pointer;
    color: #666666;
    &:hover {
      color: #3488ea;
    }
  }
  .new-name {
    color: #3488ea;
    cursor: pointer;
  }
  .fa-angle-right {
    margin: 0 5px;
  }
}
.innovative-service {
  width: 1170px;
  margin: 0 auto;
  margin-top: 60px;
  .server-text {
    font-size: 24px;
    font-weight: 300;
    line-height: 0;
    color: #444444;
    text-align: center;
  }
  .server-below {
    font-size: 15px;
    color: #666666;
    text-align: center;
    margin-bottom: 25px;
    font-family: "FZCYJ";
    letter-spacing: 1px;
    font-weight: 300;
  }
  .introduction-contain {
    width: 100%;
    height: 250px;
    position: relative;
    img {
      width: 100%;
      display: block;
      margin-top: 60px;
    }
    .library-contain {
      width: 100%;
      height: 150px;
      position: absolute;
      top: -15%;
    }
  }
  .library-text {
    font-size: 14px;
    font-weight: 300;
    line-height: 30px;
    color: #666666;
    text-align: center;
  }
  .offer-serve {
    font-size: 18px;
    font-weight: 300;
    line-height: 31px;
    color: #444444;
  }
  .service-contain {
    width: 100%;
    height: 270px;
    border-radius: 45px;
    margin: 40px 0;
    background: #ffffff;
    box-shadow: 0px 13px 42px rgba(0, 0, 0, 0.05);
    padding: 20px 0 30px 0;
    .service-img {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      img {
        display: inline-block;
      }
    }
  }
  .content-text {
    font-size: 14px;
    font-weight: 300;
    line-height: 26px;
    color: #666666;
    margin-left: 35px;
  }
}
.overview-contain {
  width: 100%;
  padding: 60px 0;
  margin-top: 80px;
  background: #f5f7fa;
  .libraries {
    width: 1170px;
    margin: 0 auto;
    .libraries-title {
      font-size: 24px;
      font-weight: 300;
      line-height: 0;
      color: #444444;
      text-align: center;
    }
    .libraries-name {
      font-size: 15px;
      color: #666666;
      text-align: center;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
    }
    .libraries-text {
      font-size: 14px;
      font-weight: 300;
      line-height: 24px;
      color: #666666;
      text-align: center;
      margin-top: 30px;
    }
    img {
      margin-top: 30px;
    }
  }
}

.overview-contain1 {
  width: 100%;
  padding: 60px 0;
  background: #ffffff;
  .libraries1 {
    width: 1170px;
    margin: 0 auto;
    .libraries-title1 {
      font-size: 24px;
      font-weight: 300;
      line-height: 0;
      color: #444444;
      text-align: center;
    }
    .libraries-name1 {
      font-size: 15px;
      color: #666666;
      text-align: center;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
    }
    .libraries-text1 {
      font-size: 14px;
      font-weight: 300;
      line-height: 24px;
      color: #666666;
      text-align: center;
      margin-top: 30px;
    }
    .area-contain {
      width: 100%;
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .area-chunk {
        width: 18%;
        height: 250px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        div:nth-of-type(1) {
          font-size: 18px;
          font-weight: 300;
          line-height: 31px;
          color: #444444;
          margin-top: 25px;
        }
        div:nth-of-type(2) {
          font-size: 14px;
          font-weight: 300;
          line-height: 24px;
          color: #999999;
          text-align: center;
          margin-top: 5px;
        }
      }
    }
  }
}

.overview-contain2 {
  width: 100%;
  padding: 60px 0;
  background: #f5f7fa;
  .libraries2 {
    width: 1170px;
    margin: 0 auto;
    .libraries-title2 {
      font-size: 24px;
      font-weight: 300;
      line-height: 0;
      color: #444444;
      text-align: center;
    }
    .libraries-name2 {
      font-size: 15px;
      color: #666666;
      text-align: center;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
    }
    .libraries-text2 {
      font-size: 14px;
      font-weight: 300;
      line-height: 24px;
      color: #666666;
      text-align: center;
      margin-top: 30px;
    }
    .support-contain {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 10px;
      .support-chunk {
        width: 47%;
        height: 150px;
        display: flex;
        flex-direction: row;
        margin-top: 30px;
        .support-left {
          width: 15%;
          height: 150px;
          background: #e9efff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .support-right {
          width: 85%;
          height: 150px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0 20px;
          box-sizing: border-box;
          div:nth-of-type(1) {
            font-size: 18px;
            font-weight: 300;
            line-height: 31px;
            color: #444444;
          }
          div:nth-of-type(2) {
            font-size: 15px;
            font-weight: 300;
            line-height: 25px;
            color: #999999;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
.overview-contain3 {
  width: 100%;
  padding: 60px 0;
  background: #ffffff;
  .libraries3 {
    width: 1170px;
    margin: 0 auto;
    .libraries-title3 {
      font-size: 24px;
      font-weight: 300;
      line-height: 0;
      color: #444444;
      text-align: center;
    }
    .libraries-name3 {
      font-size: 15px;
      font-weight: 300;
      color: #666666;
      text-align: center;
      font-family: "FZCYJ";
      letter-spacing: 1px;
    }
    .libraries-text3 {
      font-size: 14px;
      font-weight: 300;
      line-height: 24px;
      color: #666666;
      text-align: center;
      margin-top: 30px;
    }
    .quality-control {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 20px;
      .quality-chunk {
        width: 373px;
        height: 316px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border: 1px solid #eaeaea;
        margin-top: 25px;
        box-sizing: border-box;
        .quality-header {
          width: 121px;
          height: 121px;
          border-radius: 50%;
          background: #f9f9f9;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
        }
        .quality-title {
          font-size: 18px;
          font-weight: 300;
          line-height: 31px;
          color: #444444;
          margin-left: 20px;
          margin-top: 20px;
        }
        .quality-name {
          font-size: 14px;
          font-weight: 300;
          line-height: 24px;
          color: #999999;
          margin: 6px 20px 0 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Cooperation/Cooperation.vue